import { createTheme } from '@mui/material/styles';
import typography from './typography';
import * as components from './components-theme';
import breakpoints from './breakpoints';
import { darkPalette, lightPalette } from './palette';
import { shadows, transitions } from './effects';

export default function createCustomTheme(mode = 'light') {
  const palette = mode === 'dark' ? darkPalette : lightPalette;

  return createTheme({
    palette,
    typography,
    breakpoints,
    components,
    shadows,
    transitions
  });
}
